export default __webpack_public_path__ + "static/media/SearchIcon.3b91a9c7.svg";